/**
 * @module builder
 */
import type { QuoteDocument, QuoteStatus } from 'paintscout'

export function getStatus(args: { quote: QuoteDocument }): QuoteStatus {
  const { quote } = args

  return quote ? quote?.status?.value ?? 'draft' : 'draft'
}

export function getStatusNote(args: { quote: QuoteDocument; customer?: boolean }) {
  const { quote, customer } = args

  if (customer) {
    return quote?.status?.customerNote?.value ?? null
  } else {
    return quote?.status?.note?.value ?? null
  }
}
